import { render, staticRenderFns } from "./KycVerificationTab.vue?vue&type=template&id=d9c07e6c"
import script from "./KycVerificationTab.vue?vue&type=script&lang=js"
export * from "./KycVerificationTab.vue?vue&type=script&lang=js"
import style0 from "./KycVerificationTab.vue?vue&type=style&index=0&id=d9c07e6c&prod&lang=css"
import style1 from "spinkit/scss/spinkit.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports